import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {HttpClient} from "@angular/common/http";
import {Router} from "@angular/router";
import {CardsBasicComponent} from "../../../shared/components/cards/cards-basic/cards-basic.component";
import {MatFormField, MatFormFieldModule} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {MatButton} from "@angular/material/button";
import {AuthService} from "../../../shared/services/auth.service";

@Component({
  selector: 'app-password-forgot',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    CardsBasicComponent,
    MatFormField,
    MatInput,
    MatButton,
    FormsModule
  ],
  templateUrl: './password-forgot.component.html',
  styleUrl: './password-forgot.component.css'
})
export class PasswordForgotComponent implements OnInit {
  forgotForm!: FormGroup;
  isLoading = false;
  successMessage: string | null = null;
  errorMessage: string | null = null;

  constructor(private http: HttpClient,
              private router: Router,
              private authService: AuthService) {}

  ngOnInit(): void {
    this.forgotForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email])
    });
  }

  onSubmit(): void {
    if (this.forgotForm.invalid) return;
    this.isLoading = true;
    this.successMessage = null;
    this.errorMessage = null;

    const email = this.forgotForm.value.email;

    console.log('email', email)

    this.authService.forgotPassword(email).subscribe({
      next: (res: any) => {
        // Erfolgsmeldung anzeigen (neutral, kein Hinweis ob Account existiert)
        this.successMessage = 'If an account exists with this email, a reset link was sent.';
        this.isLoading = false;
      },
      error: (err: any) => {
        console.log('error', err)
        // Fehlermeldung (optional; man kann auch eine neutrale Erfolgsmeldung anzeigen)
        this.errorMessage = 'An error occurred. Please try again later.';
        this.isLoading = false;
      }
    });
  }
}
